import { ComponentStyleConfig } from '@chakra-ui/react';

const Input: ComponentStyleConfig = {
  defaultProps: {
    variant: 'primary',
  },
  sizes: {
    sm: {
      h: '30px',
      fontSize: '14px',
      px: '20px',
    },
    md: {
      h: '48px',
      fontSize: '16px',
      px: '24px',
    },
    lg: {
      h: '56px',
      fontSize: '18px',
      px: '28px',
    },
  },
  variants: {
    primary: {
      field: {
        bg: 'input-bg',
        border: '1px solid',
        borderColor: 'transparent',
        color: 'grey.800',
        _hover: {
          borderColor: 'grey.600',
        },
        _disabled: {
          bg: 'grey.200',
          color: 'grey.400',
          borderColor: 'grey.300',
        },
      },
      bg: 'input-bg',
      border: '1px solid red',
      color: 'white',
      _hover: {
        bg: 'btn-primary-pressed-bg',
        _disabled: {
          bg: 'btn-disabled-bg',
          color: 'white',
        },
      },
      _disabled: {
        bg: 'btn-disabled-bg',
        color: 'white',
        opacity: 0.9,
      },
    },
    secondary: {
      bg: 'secondary-blue',
      color: 'white',
      _hover: {
        bg: 'secondary-green',
      },
    },
  },
};

export default Input;
